import { UI_TAGS } from "@/presentation/helpers/uiTags.js";

export function createTurnBanner(k, config = {}) {
    const startX = config.x || 320;
    const startY = config.y || 35;

    // Create the Parent
    const bannerActor = k.add([
        k.pos(startX, startY),
        k.anchor("center"),
        k.z(100),
        UI_TAGS.CURRENT_TURN_BANNER
    ]);

    // Hide it on first render
    bannerActor.hidden = true;
    // Track state so we know WHEN to animate
    bannerActor.currentTeamId = null;

    // Build the Static Elements
    const titleText = bannerActor.add([
        k.text("PLAYER TURN", { size: 28, font: "lilita" }),
        k.color(255, 255, 255), // Will be updated
        k.outline(3, k.BLACK),
        k.anchor("center"),
        k.z(101),
        k.pos(0, 0)
    ]);

    const leftSheep = bannerActor.add([
        k.sprite("sheep", { anim: "idle" }),
        k.pos(-160, 0),
        k.anchor("center"),
        k.z(101),
        k.scale(0.7),
        k.color(255, 255, 255)
    ]);
    const rightSheep = bannerActor.add([
        k.sprite("sheep", { anim: "idle", flipX: true }),
        k.pos(160, 0),
        k.anchor("center"),
        k.z(101),
        k.scale(0.7),
        k.color(255, 255, 255)
    ]);

    // Random animation loop for the big sheep
    const makeSheepAlive = (sheepSprite) => {
        k.wait(k.rand(3, 10), () => {
            if (!sheepSprite.exists()) return;
            sheepSprite.play(sheepSprite.curAnim() === "idle" ? "run" : "idle");
            makeSheepAlive(sheepSprite);
        });
    };
    makeSheepAlive(leftSheep);
    makeSheepAlive(rightSheep);

    // Build the Life Icons Array
    const lifeIcons = [];
    for (let i = 0; i < 5; i++) {
        const offsetX = (i - 2) * 28;

        const sheepIcon = bannerActor.add([
            k.sprite("sheep"),
            k.pos(offsetX, 30),
            k.anchor("center"),
            k.z(101),
            k.scale(0.35),
            k.color(255, 255, 255),
            k.opacity(1)
        ]);

        const crossIcon = bannerActor.add([
            k.text("X", { size: 22, font: "lilita" }),
            k.pos(offsetX, 30),
            k.anchor("center"),
            k.z(101),
            k.color(255, 50, 50),
            k.scale(1),
            k.opacity(0)
        ]);

        lifeIcons.push({ sheep: sheepIcon, cross: crossIcon, isDead: false });
    }

    // Update all information (when there is a new turn or a kill)
    bannerActor.updateStatus = (activePlayer, duckDiscardPile) => {
        if (bannerActor.hidden) {
            bannerActor.hidden = false;
            bannerActor.pos = k.vec2(startX, -50);

            k.tween(
                -50,
                startY,
                0.5,
                (v) => bannerActor.pos = k.vec2(startX, v), // <--- THE FIX
                k.easings.easeOutBack
            );
        }

        const tColor = activePlayer.team.color;
        const rgbColor = k.rgb(tColor.r, tColor.g, tColor.b);
        const isNewTurn = bannerActor.currentTeamId !== activePlayer.team.id;

        bannerActor.currentTeamId = activePlayer.team.id;

        // Update Title & Big Sheep Colors
        titleText.text = `${activePlayer.team.id} PLAYER TURN`;
        titleText.color = rgbColor;
        leftSheep.color = rgbColor;
        rightSheep.color = rgbColor;

        // Count dead ducks for this team
        const deadDucks = duckDiscardPile.filter(c => c.team && c.team.id === activePlayer.team.id).length;

        // Update the 5 life icons
        lifeIcons.forEach((icon, i) => {
            icon.sheep.color = rgbColor;
            const shouldBeDead = i < deadDucks;

            if (isNewTurn) {
                icon.isDead = shouldBeDead;
                icon.sheep.opacity = shouldBeDead ? 0.3 : 1;
                icon.cross.opacity = shouldBeDead ? 1 : 0;
                icon.cross.scaleTo(1);
            } else {
                // The turn is the same, meaning a duck just died, play animation
                if (shouldBeDead && !icon.isDead) {
                    icon.isDead = true;
                    icon.cross.opacity = 1;

                    // The "Stomp" Animation!
                    k.tween(2.5, 1, 0.3, (v) => icon.cross.scaleTo(v), k.easings.easeOutBack);
                    k.tween(1, 0.3, 0.3, (v) => icon.sheep.opacity = v, k.easings.linear);
                }
            }
        });
    };

    return bannerActor;
}